import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgAnalysis = (props) => /* @__PURE__ */ _jsxs("svg", {
	width: 16,
	height: 16,
	viewBox: "0 0 16 16",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: [/* @__PURE__ */ _jsx("g", {
		clipPath: "url(#clip_analysis)",
		children: /* @__PURE__ */ _jsx("path", {
			d: "M15.8047 15.8047C15.6747 15.9347 15.504 16 15.3333 16C15.1627 16 14.992 15.9347 14.862 15.8047L10.8827 11.8253C9.73267 12.7667 8.26467 13.3333 6.66667 13.3333C2.99067 13.3333 0 10.3427 0 6.66667C0 2.99067 2.99067 1.93162e-10 6.66667 1.93162e-10C7.83867 1.93162e-10 8.99133 0.308667 10.0007 0.892C10.3193 1.07667 10.4287 1.48467 10.2433 1.80333C10.12 2.01667 9.896 2.136 9.666 2.136C9.55267 2.136 9.438 2.10733 9.33267 2.04667C8.52667 1.58 7.60467 1.33333 6.66667 1.33333C3.726 1.33333 1.33333 3.726 1.33333 6.66667C1.33333 7.44467 1.50467 8.18267 1.806 8.84933L4.33867 5.81C4.58 5.51933 4.936 5.34333 5.31333 5.326C5.688 5.30933 6.06133 5.45133 6.32933 5.72L7.61467 7.00533L13.4913 0.226667C13.7327 -0.0526667 14.154 -0.0813333 14.4313 0.158C14.71 0.398667 14.7413 0.82 14.5007 1.09867L8.64733 7.876C8.40333 8.15867 8.04933 8.32867 7.67533 8.34267C7.304 8.352 6.93667 8.21267 6.672 7.948L5.38667 6.66267L2.54467 10.046C3.52333 11.238 5.008 11.9993 6.66667 11.9993C9.60733 11.9993 12 9.60667 12 6.666C12 6.566 11.9967 6.46667 11.9913 6.368C11.972 6 12.2547 5.68667 12.622 5.66667C12.9867 5.64 13.3033 5.92933 13.3233 6.29667C13.33 6.41867 13.3333 6.542 13.3333 6.66533C13.3333 8.264 12.7667 9.732 11.8253 10.8813L15.8047 14.8607C16.0653 15.1213 16.0653 15.5427 15.8047 15.8033V15.8047Z",
			fill: "currentColor"
		})
	}), /* @__PURE__ */ _jsx("defs", { children: /* @__PURE__ */ _jsx("clipPath", {
		id: "clip_analysis",
		children: /* @__PURE__ */ _jsx("rect", {
			width: 16,
			height: 16,
			fill: "white"
		})
	}) })]
});
export default SvgAnalysis;
